
<div class="modal-body">
    <div class="row">
        <div class="col-lg-12">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="this.activeModal.dismiss()">
                <span aria-hidden="true"><img src="./assets/img/times.svg" class="img-fluid ico-title" width="20"></span>
            </button>
            <div class="d-flex justify-content-between align-items-center mt-3">

                <div class="p-2 bd-highlight"><h5 align="center" class="tar-name">{{ rate.name }} {{ subrate ? ' + ' + subrate.name : ''}}</h5></div>

                <div class="p-2 bd-highlight"><h5 align="center" class="tar-price">{{ totalRate() }}<span> €/mes</span></h5></div>
                <div class="p-2 bd-highlight mobile"><span class="vl"></span></div>
                <div class="p-2 bd-highlight mobile">
                    <h5 align="center" class="tar-name-4">{{ rate.labelData }}</h5>
                    <h5 align="center" class="tar-name-4" *ngIf="subrate != null">+ {{ subrate.labelData }}</h5>
                    <h5 align="center" class="tar-name-5 mb-1">Navegación</h5>

                </div>
                <div class="p-2 bd-highlight mobile"><span class="vl"></span></div>
                <div class="p-2 bd-highlight mobile">
                    <h5 align="center" class="tar-name-5 mt-2">{{ rate.resumeLabelVoice }} </h5>
                    <h5 align="center" class="tar-name-5 mt-2" *ngIf="subrate">{{ subrate.resumeLabelVoice }} </h5>
                    <!--<h5 align="center" class="tar-name-5 mt-2" *ngIf="subrate">{{ subrate.resumeLabelVoice }} </h5>-->
                    <h5 align="center" class="tar-name-4"></h5></div>
            </div>

            <div class="bb-line"></div>
            <br>



            <ng-container *ngFor="let rateDescriptions of ratesDescriptions | keyvalue: asIsOrder">
                <ng-container *ngIf="typeOrder !== 'mobile' && rateDescriptions.key == '0'">
                    <ng-container *ngFor="let item of rateDescriptions.value | keyvalue: asIsOrder">
                        <h5 class="desc-title"><b>{{ item.key.length > 0 ? item.key : 'Móvil'  }}</b></h5>
                        <ul class="desc-ul">
                            <li class="desc-li" *ngFor="let description of item.value"> {{ description }}</li>
                        </ul>
                        <!--</ng-container>-->
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="typeOrder === 'mobile' || rateDescriptions.key > 0">
                    <h5 class="desc-title"><b>Móvil</b></h5>
                    <ul class="desc-ul">
                        <ng-container *ngFor="let item of rateDescriptions.value | keyvalue: asIsOrder">
                            <li class="desc-li" *ngFor="let description of item.value"> <b> {{ item.key.length > 0 ? item.key + ': ' : ''  }}</b> {{ description }}</li>
                        </ng-container>
                    </ul>
                </ng-container>

            </ng-container>

        </div>
    </div>
</div>

